module.exports = __webpack_public_path__ + "img/design1.7dba6542.svg";